export default __webpack_public_path__ + "static/media/5-temple.a2d2197f.png";